import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionService } from '../services/session.service';
import { projectConfiguration } from '../modules/app/app.module';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const sessionS = inject(SessionService);

  if (!sessionS.hasSession()) {
      router.navigate([projectConfiguration.landingView.path], { 
        queryParams: { returnUrl: state.url }
      });
      return false;
  }
  return true;
};
